/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
==========================================================================================*/


export default {
  UPDATE_ARTICLE(state, payload) {
    if (payload != null)
      state.articles = payload;
  },
  UPDATE_PERIODE(state,payload)
  {
    state.periode=payload
  },
  UPDATE_PERIODE_YEAR(state,payload){
    state.selectedyear=payload ;
  }
}
